/* eslint-disable */

const GET_AJ_TASKS = 'dofe-bo/ajTasks/GET_AJ_TASKS'
const GET_AJ_TASKS_SUCCESS = 'dofe-bo/ajTasks/GET_AJ_TASKS_SUCCESS'
const GET_AJ_TASKS_FAIL = 'dofe-bo/ajTasks/GET_AJ_TASKS_FAIL'
const GET_AJ_TASKS_EVENTS = 'dofe-bo/ajTasks/GET_AJ_TASKS_EVENTS'
const GET_AJ_TASKS_EVENTS_SUCCESS =
  'dofe-bo/ajTasks/GET_AJ_TASKS_EVENTS_SUCCESS'
const GET_AJ_TASKS_EVENTS_FAIL = 'dofe-bo/ajTasks/GET_AJ_TASKS_EVENTS_FAIL'
const GET_AJ_TASKS_PREPERATION = 'dofe-bo/ajTasks/GET_AJ_TASKS_PREPERATION'
const GET_AJ_TASKS_PREPERATION_SUCCESS =
  'dofe-bo/ajTasks/GET_AJ_TASKS_PREPERATION_SUCCESS'
const GET_AJ_TASKS_PREPERATION_FAIL =
  'dofe-bo/ajTasks/GET_AJ_TASKS_PREPERATION_FAIL'
const SET_FILTER = 'dofe-bo/ajTasks/SET_FILTER'
const SET_BASE_FILTER = 'dofe-bo/ajTasks/SET_BASE_FILTER'
const SET_TASKS_AJ_EVENTS_PARAMS = 'dofe-bo/ajTasks/SET_TASKS_AJ_EVENTS_PARAMS'
const SET_TASKS_AJ_PARTICIPANT_EVENTS_PARAMS =
  'dofe-bo/ajTasks/SET_TASKS_AJ_PARTICIPANT_EVENTS_PARAMS'
const SET_TASKS_AJ_PREP_PARAMS = 'dofe-bo/ajTasks/SET_TASKS_AJ_PREP_PARAMS'
const SET_DISABLED_CACHE = 'dofe-bo/ajTasks/SET_DISABLED_CACHE'
const REMOVE_DETAIL_DATA = 'dofe-bo/ajTasks/REMOVE_DETAIL_DATA'

const initialState = {
  events: {
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    invalidate: null,
    loading: false,
    loaded: false
  },
  participantEvents: {
    list: [],
    loading: false,
    loaded: false,
    sort: '',
    invalidate: null,
    offset: 0,
    limit: 20,
    pages: 1,
    count: null
  },
  preparationAndTraining: {
    list: [],
    loading: false,
    loaded: false,
    sort: '',
    invalidate: null,
    offset: 0,
    limit: 20,
    pages: 1,
    count: null
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_AJ_TASKS_EVENTS:
      return {
        ...state,
        events: {
          ...state.events,
          loading: true
        }
      }
    case GET_AJ_TASKS_EVENTS_SUCCESS:
      return {
        ...state,
        events: {
          ...state.events,
          list: action.result,
          count: action.headers['x-total-count'],
          pages:
            Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
            state.pages,
          loading: false,
          loaded: true
        }
      }
    case GET_AJ_TASKS_EVENTS_FAIL:
      return {
        ...state,
        error: action.error,
        events: {
          ...state.events,
          loading: false,
          loaded: false
        }
      }
    case GET_AJ_TASKS:
      return {
        ...state,
        participantEvents: {
          ...state.participantEvents,
          loading: false
        }
      }
    case GET_AJ_TASKS_SUCCESS:
      return {
        ...state,
        participantEvents: {
          ...state.participantEvents,
          list: action.result,
          count: action.headers['x-total-count'],
          pages:
            Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
            state.pages,
          loading: false,
          loaded: true
        }
      }
    case GET_AJ_TASKS_FAIL:
      return {
        ...state,
        participantEvents: {
          ...state.participantEvents,
          loading: false
        },
        error: action.error
      }
    case GET_AJ_TASKS_PREPERATION:
      return {
        ...state,
        preparationAndTraining: {
          ...state.preparationAndTraining,
          loading: false
        }
      }
    case GET_AJ_TASKS_PREPERATION_SUCCESS:
      return {
        ...state,
        preparationAndTraining: {
          ...state.preparationAndTraining,
          list: action.result,
          count: action.headers['x-total-count'],
          pages:
            Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
            state.pages,
          loading: false,
          loaded: true
        }
      }
    case GET_AJ_TASKS_PREPERATION_FAIL:
      return {
        ...state,
        preparationAndTraining: {
          ...state.preparationAndTraining,
          loading: false
        },
        error: action.error
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy,
        invalidate: new Date().getTime()
      })
    case SET_BASE_FILTER:
      return Object.assign({}, state, {
        baseFilter: action.filterBy,
        invalidate: new Date().getTime()
      })
    case SET_TASKS_AJ_EVENTS_PARAMS:
      return {
        ...state,
        events: {
          ...state.events,
          limit:
            action.options.limit !== undefined
              ? action.options.limit
              : state.events.limit,
          offset:
            action.options.offset !== undefined
              ? action.options.offset
              : state.events.offset,
          filter:
            action.options.filter !== undefined
              ? action.options.filter
              : state.events.filter,
          sort:
            action.options.sort !== undefined
              ? action.options.sort
              : state.events.sort,
          invalidate: _.isEmpty(action.options)
            ? state.events.invalidate
            : new Date().getTime()
        }
      }
    case SET_TASKS_AJ_PARTICIPANT_EVENTS_PARAMS:
      return {
        ...state,
        participantEvents: {
          ...state.participantEvents,
          limit:
            action.options.limit !== undefined
              ? action.options.limit
              : state.participantEvents.limit,
          offset:
            action.options.offset !== undefined
              ? action.options.offset
              : state.participantEvents.offset,
          filter:
            action.options.filter !== undefined
              ? action.options.filter
              : state.participantEvents.filter,
          sort:
            action.options.sort !== undefined
              ? action.options.sort
              : state.participantEvents.sort,
          invalidate: _.isEmpty(action.options)
            ? state.participantEvents.invalidate
            : new Date().getTime()
        }
      }
    case SET_TASKS_AJ_PREP_PARAMS:
      return {
        ...state,
        preparationAndTraining: {
          ...state.preparationAndTraining,
          limit:
            action.options.limit !== undefined
              ? action.options.limit
              : state.preparationAndTraining.limit,
          offset:
            action.options.offset !== undefined
              ? action.options.offset
              : state.preparationAndTraining.offset,
          filter:
            action.options.filter !== undefined
              ? action.options.filter
              : state.preparationAndTraining.filter,
          sort:
            action.options.sort !== undefined
              ? action.options.sort
              : state.preparationAndTraining.sort,
          invalidate: _.isEmpty(action.options)
            ? state.preparationAndTraining.invalidate
            : new Date().getTime()
        }
      }
    case SET_DISABLED_CACHE:
      return Object.assign({}, state, {
        loaded: false
      })
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {}
      })
    default:
      return state
  }
}

export function getTasksAjEvents({ sort = null }, filter) {
  const sortQuery = (sort && `&sort=${sort}`) || ''
  const filterQuery = (filter && `&filter=${filter}`) || ''

  return {
    types: [
      GET_AJ_TASKS_EVENTS,
      GET_AJ_TASKS_EVENTS_SUCCESS,
      GET_AJ_TASKS_EVENTS_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/aj-event-approval?with=APPEND_CUSTOMIZATIONS,AWARD,AJ_EVENT,CATEGORY_IN_DESCRIPTION,AJ_TYPE,ASSESSOR,AJ_CREATED_BY${sortQuery}${filterQuery}`
      )
  }
}

export function getTasksAjParticipantEvents({
  filter = null,
  limit,
  offset,
  sort
}) {
  const query = filter ? `&filter=${filter}` : ''
  const firstRow = (offset && `&firstRow=${offset}`) || ''
  const maxRows = (limit && `&maxRows=${limit}`) || ''
  const getTotalRowCount = '&getTotalRowCount=true'
  const sortQuery = (sort && `&sort=${sort}`) || ''

  return {
    types: [GET_AJ_TASKS, GET_AJ_TASKS_SUCCESS, GET_AJ_TASKS_FAIL],
    promise: client =>
      client.get(
        `api/tasks/aj-participant-event-signoff?with=AJ_PARTICIPANT_EVENT,PARTICIPANT_PERSON,AWARD,ASSESSOR,AJPE_COMPLETION_FILES${query}${maxRows}${firstRow}${getTotalRowCount}${sortQuery}`
      )
  }
}

export function getTasksAjPreparationAndTraining({
  filter = null,
  limit,
  offset,
  sort
}) {
  const query = filter ? `&filter=${filter}` : ''
  const firstRow = (offset && `&firstRow=${offset}`) || ''
  const maxRows = (limit && `&maxRows=${limit}`) || ''
  const getTotalRowCount = '&getTotalRowCount=true'
  const sortQuery = (sort && `&sort=${sort}`) || ''

  return {
    types: [
      GET_AJ_TASKS_PREPERATION,
      GET_AJ_TASKS_PREPERATION_SUCCESS,
      GET_AJ_TASKS_PREPERATION_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/aj-preparation-and-training-signoff?with=AWARD_LEVEL,AJ_PARTICIPANT_EVENT,PARTICIPANT_PERSON${query}${maxRows}${firstRow}${getTotalRowCount}${sortQuery}`
      )
  }
}

export function setFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setBaseFilter(filterBy) {
  return {
    type: SET_BASE_FILTER,
    filterBy
  }
}

export function setTasksAjEventsParams(options) {
  return {
    type: SET_TASKS_AJ_EVENTS_PARAMS,
    options
  }
}

export function setTasksAjParticipantEventsParams(options) {
  return {
    type: SET_TASKS_AJ_PARTICIPANT_EVENTS_PARAMS,
    options
  }
}

export function setTasksAjPrepParams(options) {
  return {
    type: SET_TASKS_AJ_PREP_PARAMS,
    options
  }
}

export function removeDetailData() {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function removeCache() {
  return {
    type: SET_DISABLED_CACHE
  }
}
/* eslint-enable */
